import React from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import BaseText from './BaseText';
import { useActionSheet } from '@expo/react-native-action-sheet';

import { Color, CommonProperties, CommonStyles } from '../styles';
import { AntDesign } from '@expo/vector-icons';

export const ActionSheetDropdown = (props) => {
  const { selectedOption, onChangedOption, containerStyle, onDropdownPress } = props;
  // we check if options is an object array or not
  // options must be [{text:string,underText:string}]
  const options =
    typeof props.options[0] !== 'object'
      ? props.options.map((o) => {
          return { text: o };
        })
      : props.options;
  const { showActionSheetWithOptions } = useActionSheet();
  //if option sent is not found it'll return -1; to fix it we pick the max value between 0 and the mentioned
  const cancelButtonIndex = Math.max(
    0,
    options.findIndex((option) => option.text === selectedOption)
  );
  const defaultOption = options[Math.max(cancelButtonIndex)];
  const UnderText = ({ children }) => {
    return (
      <BaseText style={{ color: Color.grayText, ...CommonProperties.small }}>
        {children !== undefined && `\n${children}`}
      </BaseText>
    );
  };
  return (
    <View style={containerStyle}>
      <TouchableOpacity
        style={styles.rowButton}
        onPress={() => {
          showActionSheetWithOptions(
            { options: options.map((option) => option.text), cancelButtonIndex },
            (buttonIndex) => {
              onChangedOption(options[buttonIndex].text);
            }
          );
          if (onDropdownPress) {
            onDropdownPress();
          }
        }}
      >
        <View style={styles.centerElements}>
          <BaseText style={[CommonStyles.h2, CommonStyles.ml2, styles.customLineHeight]}>
            {defaultOption.text}
            <UnderText>{defaultOption.underText}</UnderText>
          </BaseText>
          <View style={CommonStyles.flex1}>
            <AntDesign
              color={Color.primary}
              style={CommonStyles.alignSelfToEnd}
              name="caretdown"
              size={22}
            />
          </View>
        </View>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  rowButton: {
    borderBottomWidth: 0.7,
    borderColor: Color.shadow,
    ...CommonProperties.p3,
  },
  centerElements: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  customLineHeight: {
    lineHeight: 12,
  },
});
